import React, { Fragment } from "react";
import styled from "@emotion/styled";
import { FlexWrapperT1 } from "Components/Common/Wrapper/FlexWrapper";
import {
  TypographyT8,
  TypographyT9,
  TypographyT10,
  TypographyT11,
  TypographyT12,
  TypographyT5,
} from "Components/Common/Typography/index";

const FreightInformationCard = (props) => {
  const { lowestFreight } = props;
  const shouldRenderTAT = () => {
    const C1 = !!lowestFreight.tat;

    if (C1) {
      return true;
    }
    return false;
  };
  return (
    <Fragment>
      <FreightInformationCardWrapper>
        <TopRightBox>Lowest Freight</TopRightBox>
        <TopWrapper>
          <FlexWrapperT1>
            <TypographyT8 variant="h4">
              <span style={{ fontFamily: "Roboto" }}>₹ </span>
              {lowestFreight.sum_of_bid_price}
            </TypographyT8>
            <TypographyT9 variant="h5">/MT</TypographyT9>
          </FlexWrapperT1>
          {shouldRenderTAT() && (
            <TypographyT10 variant="h6">
              {`TAT - ${lowestFreight.tat.value} ${lowestFreight.tat.name}`}
            </TypographyT10>
          )}
        </TopWrapper>
        <ButtomWrapper>
          <TypographyT10 variant="h6">
            {`${lowestFreight.from} - ${lowestFreight.to}`}
          </TypographyT10>
          {/* <TypographyT11 variant="h5">
            (Rail Freight BCN for Full Rake)
          </TypographyT11> */}
          {/* <TypographyT12 variant="h6">
            Alwar - Alwar Yard - Mohanlal ganj - Lucknow
          </TypographyT12> */}
        </ButtomWrapper>
      </FreightInformationCardWrapper>
    </Fragment>
  );
};

export default FreightInformationCard;

const FreightInformationCardWrapper = styled("div")`
  background-color: #4e9757;
  border-radius: 6px;
  padding: 15px;
  position: relative;
`;
const TopWrapper = styled("div")`
  display: flex;
  gap: 32px;
  align-items: center;
`;
const ButtomWrapper = styled("div")`
  display: flex;
  gap: 24px;
  align-items: center;
`;
const TopRightBox = styled(TypographyT5)`
  position: absolute;
  top: 0;
  right: 0;
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  background-color: #3e7946;
  padding: 8px 15px;
  border-top-right-radius: 6px;
`;
